module.exports = __webpack_public_path__ + "static/media/corporate-services-img43.75acaa83.jpg";